export function toGraylog(message: string, data?: any) {
    const requestData = {
        version: '0.1',
        project_id: 'oliverbonas_prod',
        source: 'oliverbonas_prod',
        host: location.host,
        url: location.href,
        environment: 'prod',
        facility: 'frontend',
        level: 1,
        short_message: message
    };

    if (data) {
        let key;
        for (key in data) {
            requestData['_' + key] = data[key];
        }
    }

    const http = new XMLHttpRequest();
    http.open('POST', '/gl', true);
    http.setRequestHeader('Content-type', "Content-type':'application/json");
    http.setRequestHeader('Access-Control-Allow-Origin', 'Origin,Content-Type,Accept');
    http.send(JSON.stringify(requestData));
}
